export default __webpack_public_path__ + "9510ea741dfe5800af84eef33c5cdfaf.svg";